import useData from "./useData";
import { Token } from "./types";

export default function useTokens(envPubId: string | undefined) {
  return useData<Token[]>(() =>
    envPubId ? `/web/environment/${envPubId}/tokens` : null
  );
}
